import * as React from 'react';
import { flow, forEach, get, map, values } from 'lodash';
import { II18nMessages } from '../../../../services/branding/models';
import {Button, Col, Form, Modal, Row} from 'react-bootstrap';
import { Field, formValueSelector, InjectedFormProps, reduxForm, submit } from 'redux-form';
import { IOptionMap, IProduct } from '../../../../data/api/models';
import SelectControl from '../../../../components/SelectControl';
import { IQuoteActions, IQuoteState } from '../../../../services/quote/models';
import { isRequired } from '../../../../util/validators';
import FaCheck from 'react-icons/fa/check';
import FaClose from 'react-icons/fa/close';
import FieldFormControl from '../../../../components/FieldFormControl';
import { connect } from 'react-redux';
import * as Commonmark from 'react-commonmark';
import { bindActionCreators } from 'redux';
import { actions as quoteActions } from '../../../../services/quote/reducer';
import { push } from 'react-router-redux';
import Loading from '../../../../components/Loading';
import { IStore } from '../../../../redux/IStore';
import FaInfoCircle from 'react-icons/fa/info-circle';
import * as moment from 'moment';
import VehicleDetails from './components/VehicleDetails';

interface IAdditionalCoverForm extends InjectedFormProps {
  i18n: II18nMessages;
  quote: IQuoteState;
  product: IProduct;
  startDate: string;
  endDate: string;
  pristine: boolean;
  submitting: boolean;
  onBack: () => void;
  options: IOptionMap;
  dispatch: any;
  renderDefinition(name: string, defName?: string): any;
  channel: any;
  actions: {
    submit(name: string);
    push: (route: string) => void;
    quote: IQuoteActions;
  };
}

interface IAdditionalCoverForm {
  showPartCMessageModal: boolean;
}

class AdditionalCoverForm extends React.Component<IAdditionalCoverForm> {
  public state = {
    showPartCMessageModal: false,
  };

  private closeUpSellModal = () => {
    const {change, dispatch } = this.props;
    dispatch(change('options.part_b', false));
    dispatch(change('options.part_c', false));
    this.setState({
      showPartCMessageModal: false,
    });
  }

  private handleSubmit = () => {
    this.setState({
      showPartCMessageModal: false,
    });
  }

  private openUpSellModal = () => {
    const { dispatch, change } = this.props;
    dispatch(change(`options.part_b`, true));
    this.setState({
      showPartCMessageModal: true,
    });
  }

  public componentWillReceiveProps(nextProps) {
    const { quote, change, channel, options } = this.props;
    const getAllOptions = get(quote, 'application.premiums[0].information.availableOptions');

    forEach(getAllOptions, (option, key) => {
      if (option.default) {
        if ((nextProps.options && !nextProps.options[`${key}`]) || !nextProps.options) {
          change(`options.${key}`, option.default);
        }
      }
    });

    if (options
        && (channel.key === 'adv-b2c' || channel.key === 'pst-b2c')
        && get(options, 'part_c', false)
        && !get(options, 'part_b', false)) {
          this.openUpSellModal();
    }
  }

  private renderOption = (option, key) => {
    const { quote, channel } = this.props;
    let excludeWinter = false;
    const channelKey = get(channel, 'key');

    forEach(quote.application.travellers, (traveller) => {
      const travellerDate = moment(get(traveller, 'dob'), 'DD/MM/YYYY');
      const todayDate = moment();

      if (channelKey === 'cps-b2c' && 75 <= todayDate.diff(travellerDate, 'years')) {
        excludeWinter = true;
      }

      if (get(traveller, 'screening.meta.hasWinterSportsExclusion')) {
        excludeWinter = true;
      }
    });
    if (option.name === 'Winter Sports' && excludeWinter) {
      return;
    }
    switch (option.input_type) {
      case 'enum':
        return this.renderListOption(option, key);
      case 'boolean':
        return this.renderQuestionOption(option, key);
      default:
        return null;
    }
  }

  private recalculatePrice = () => {
    const { actions } = this.props;
    setTimeout((() => {
      actions.quote.calculate(null, true);
    }), 300);
  }

  private renderListOption = (option, key) => {
    const { renderDefinition, quote } = this.props;
    const pack = get(quote, 'application.options.hazardous_activities', 'pack1');
    const list = map(option.options, (item) => {
      return {
        label: item.name,
        value: item.key,
      };
    });

    return (
      <div key={key} className="options-section">
        <Row>
          <Col md={12} lg={6}>
            <div className="question-text">
              <div className="title">
              <div>{option.name} {renderDefinition(key)} {renderDefinition(pack, pack)}</div>
              </div>
            </div>
          </Col>
          <Col md={12} lg={6}>
            <Field
              name={`options.${key}`}
              type="select"
              options={list}
              component={SelectControl}
              clearable={false}
              validate={[isRequired]}
              onChange={this.recalculatePrice}
            />
          </Col>
        </Row>
      </div>
    );
  }

  private renderPartCMessageModal = () => {
    return (
        <Modal show={this.state.showPartCMessageModal} onHide={this.closeUpSellModal}>
          <Modal.Header closeButton={true}>
            <Modal.Title>Would You Like to Continue</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="section-group">
              <div className="section">
                Part C can only be selected with Part B, if you are happy with this please continue with your quote.
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
                bsStyle="primary"
                className="btn-remove-border"
                type="submit"
                onClick={this.handleSubmit}
            >
              Continue
            </Button>
          </Modal.Footer>
        </Modal>
    );
  }

  private renderQuestionOption = (option, key) => {
    const { channel, quote, renderDefinition } = this.props;
    const getAllOptions = get(quote, 'application.premiums[0].information.availableOptions');

    if (key === 'cruise_cover' && channel.key !== 'dia-b2c') {
      return null;
    }

    const listOfAutoIncluded = [];

    forEach(getAllOptions, (option) => {
      if (option.auto_include === true && option.input_type !== 'enum') {
        listOfAutoIncluded.push(option.key);
      }
    });

    if (listOfAutoIncluded.indexOf(key) !== -1) {
      // dispatch(change(`options.${key}`, true));
      return (
        <div key={key}>
          <div className="options-section">
            <Row>
              <Col sm={8}>
                <div className="question-text">
                  <div className="title">
                    {option.name} {renderDefinition(key)}
                  </div>
                </div>
              </Col>
              <Col sm={4} className="option-question-disabled">
                <Field
                  name={`options.${key}`}
                  type="checkbox"
                  value={true}
                  complexValue={false}
                  className="answer"
                  component={FieldFormControl}
                  disabled={true}
                  // onClick={this.recalculatePrice}
                >
                  <div className="option-btn included">
                    <div className="option-content">
                      <span className="auto-included">Included  </span>
                    </div>
                  </div>
                </Field>
              </Col>
            </Row>
          </div>
        </div>
      );
    }

    return (
      <div key={key}>
        <div className="options-section">
          <Row>
            <Col sm={8}>
              <div className="question-text">
                <div className="title">
                  {option.name} {renderDefinition(key)}
                </div>
              </div>
            </Col>
            <Col sm={4} className="option-question">
              <Field
                name={`options.${key}`}
                type="checkbox"
                value={true}
                complexValue={false}
                className="answer"
                component={FieldFormControl}
                disabled={quote.isCalculating}
                onClick={this.recalculatePrice}
              >
                <div className="option-btn">
                  <div className="option-content">
                    <span className="add">Add  </span>
                    <span className="remove">Remove  </span>
                  </div>
                </div>
              </Field>
            </Col>
          </Row>
        </div>
        {this.renderPartCMessageModal()}
      </div>
    );
  }

  private renderBooleanOption = (option, key) => {
    const { renderDefinition } = this.props;

    return (
      <div className="radio-question additional-option" key={key}>
        <Row>
          <Col md={12} lg={8}>
            <div className="question-text">
              <div>
                {option.question} {renderDefinition(key)}
              </div>
            </div>
          </Col>
          <Col md={12} lg={4}>
            <Field
              name={`options.${key}`}
              type="radio"
              value={false}
              complexValue={true}
              className="answer"
              component={FieldFormControl}
              validate={[
                isRequired,
              ]}
            >
              <div className="medical-btn">
                <FaClose /> No
              </div>
            </Field>
            <Field
              name={`options.${key}`}
              type="radio"
              value={true}
              complexValue={true}
              className="answer"
              component={FieldFormControl}
              validate={[
                isRequired,
              ]}
            >
              <div className="medical-btn">
                <FaCheck /> Yes
              </div>
            </Field>
          </Col>
        </Row>
      </div>
    );
  }

  private transformLinks = (url) => {
    const { product } = this.props;

    if (url === 'hazardous_activities') {
      return product.documents[Object.keys(product.documents)[0]];
    }

    return url;
  }

  public render() {
    const {
      handleSubmit,
      product,
      quote,
      channel,
      submitting,
      submitFailed,
      renderDefinition,
      valid,
      onBack,
    }
    = this.props;
    const hideHeader = !['dia-b2c'].includes(channel.key);
    // todo: remove lodash
    const getAllOptions = get(quote, 'application.premiums[0].information.availableOptions');
    const quotes = quote.quotes;
    const hasFinishedCalculation = values(quotes).length === 1;
    let coverSubTitle = 'You can select from below additional cover required.';
    if (['cps-b2c'].includes(channel.key)) {
      coverSubTitle = 'Please select additional cover below.';
    }
    return (
      <Form onSubmit={handleSubmit} autoComplete="off">
        <div className="steps-container">
          <div className="section-title">
            <h1>Additional Options</h1>
            {product.metadata.hazardous_activities && product.documents && (
              <Commonmark
                source={product.metadata.hazardous_activities}
                linkTarget="_blank"
                transformLinkUri={this.transformLinks}
              />
            )}
          </div>
          {hideHeader && (
            <div className="cover-sub-title">{coverSubTitle}</div>
          )}
          <div className="margin-top">
            <Commonmark className="important" source={product.metadata.definitions.optional_extras} />
              {product.metadata.definitions.optional_extras && (
                  <div>Click the<FaInfoCircle className="info-btn"/> for more information.</div>
              )}
          </div>
          <div className="options-section-group">
            {hasFinishedCalculation ? (
                map(getAllOptions, this.renderOption)
            ) : (
              <Loading/>
            )}
          </div>
          <VehicleDetails renderDefinition={renderDefinition} channelKey={channel.key}/>
          <div className="btn-bar">
            <Button
              bsStyle="primary"
              type="submit"
              className="pull-right btn-remove-border"
              disabled={submitting || (submitFailed && !valid)}
            >
                Continue
            </Button>
            <Button type="button" className="btn-back btn-remove-border" onClick={onBack}>
              Back
            </Button>
          </div>
        </div>
      </Form>
    );
  }
}

let selector;

export default flow([
  reduxForm({
    form: 'quote',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('quote');

    return component;
  },
  connect(
    (state: IStore) => {
      const quote = state.quote;
      const options = selector(state, 'options');
      const schemeId = selector(state, 'schemeId');
      const startDate = selector(state, 'startDate');
      const endDate = selector(state, 'endDate');

      return {
        options,
        quote,
        schemeId,
        startDate,
        endDate,
      };
    },
    (dispatch) => ({
      actions: {
        dispatch,
        submit: bindActionCreators(submit, dispatch),
        quote: bindActionCreators({...quoteActions}, dispatch),
        push: bindActionCreators(push, dispatch),
      },
    }),
  ),
])(AdditionalCoverForm);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/AdditionalCover/index.tsx